import type { OpenAPI } from "simplydo/interfaces";

import type { ChipUser } from "components/lib/Chips/types";

export type IdeaBusinessProfile = OpenAPI.Schemas["IdeaBusinessProfile"];

export type BusinessProfileIdea = NonNullable<
  OpenAPI.GET<"/users/profiles/{business_profile_id}">["response"]["ideaBusinessProfile"]["ownerIdeas"]
>[number] & { owner?: ChipUser; labels?: string[] };

export type IdeaBusinessProfileContact = NonNullable<
  IdeaBusinessProfile["contacts"]
>[number];

export type IdeaBusinessProfileAddress = NonNullable<
  IdeaBusinessProfile["addresses"]
>[number];

export type IdeaBusinessProfileUpdate = Partial<
  OpenAPI.POST<"/users/profiles/{business_profile_id}">["requestBody"]
>;

export type IdeaBusinessProfileUpdateResponse =
  OpenAPI.POST<"/users/profiles/{business_profile_id}">["response"];

export type IdeaBusinessProfileDeleteResponse =
  OpenAPI.DELETE<"/users/profiles/{business_profile_id}">["response"];

export type EditableContact = {
  id: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  jobTitle: string;
};

export type EditableAddress = {
  id: string;
  streetAddress: string;
  city: string;
  postcode: string;
  country: string;
  region: string;
};

export type GatherAdditionalDataResult = {
  success: boolean;
  data?: {
    foundingYear?: number;
    size?: IdeaBusinessProfile["size"];
    type?: IdeaBusinessProfile["type"];
    description?: string;
    image?: string;
  };
};

export type BusinessProfileRoleUser = NonNullable<
  OpenAPI.GET<"/roles/{for_type}/{for_id}/users">["response"]["users"]
>[number];

export type CompaniesHouseCompany = {
  company_name?: string;
  links?: { self?: string };
};

export const toEditableContact = (
  contact: IdeaBusinessProfileContact,
): EditableContact => ({
  id: contact.id ?? "",
  fullName: contact.fullName ?? "",
  email: contact.email ?? "",
  phoneNumber: contact.phoneNumber ?? "",
  jobTitle: contact.jobTitle ?? "",
});

export const toEditableAddress = (
  address: IdeaBusinessProfileAddress,
): EditableAddress => ({
  id: address.id ?? "",
  streetAddress: address.streetAddress ?? "",
  city: address.city ?? "",
  postcode: address.postcode ?? "",
  country: address.country ?? "",
  region: address.region ?? "",
});
